// extracted by mini-css-extract-plugin
module.exports = {"container":"Tweet_container__VL6P9","textarea":"Tweet_textarea__nhkcl","buttons":"Tweet_buttons__dukIG","button":"Tweet_button__2Nb7_","tweetButton":"Tweet_tweetButton__BZZHu"};